import { useStaticQuery, graphql } from "gatsby"

const { CLOUDFLARE_IMAGE_URL } = process.env

const useLogoImage = () => {
  return CLOUDFLARE_IMAGE_URL + "/static/assets/images/tmu-logo-original.png"
}

export default useLogoImage
